import axios from '../../axios';

export default {
  namespaced: true,
  state: { },
  getters: { },
  mutations: { },
  actions: {
    fetchClientManager({ commit, dispatch, getters }, id) {
      return new Promise((resolve, reject) => {
        const odata = '$select=id,fullName,userPic,userPitch,email,experienceGroupEmail';
        axios.get(`/core/users/${id}?${odata}`, {
        }).then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
      });
    },
  },
};
